module.exports = __webpack_public_path__ + "img/logo-excel.517dab9c.jpg";